import { render, staticRenderFns } from "./LinkSignIn.vue?vue&type=template&id=39aa687a&"
import script from "./LinkSignIn.vue?vue&type=script&lang=js&"
export * from "./LinkSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aa687a')) {
      api.createRecord('39aa687a', component.options)
    } else {
      api.reload('39aa687a', component.options)
    }
    module.hot.accept("./LinkSignIn.vue?vue&type=template&id=39aa687a&", function () {
      api.rerender('39aa687a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/LinkSignIn.vue"
export default component.exports